import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  NonRemittanceSummary,
  NonRemittanceSummaryVariables
} from "./types/NonRemittanceSummary";
import { Remittance, RemittanceVariables } from "./types/Remittance";
import {
  RemittancePending,
  RemittancePendingVariables
} from "./types/RemittancePending";
import {
  RemittanceReport,
  RemittanceReportVariables
} from "./types/RemittanceReport";

export const RemittanceQuery = gql`
  ${pageInfoFragment}
  query Remittance(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: RemittanceTopSheetFilterInput!
  ) {
    remittanceTopSheet(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          total_completed_amount
          rider_name
          gm_shipped_count
        }
      }
    }
  }
`;
export const useRemittanceQuery = makeBossQuery<
  Remittance,
  RemittanceVariables
>(RemittanceQuery);

export const RemittanceReportQuery = gql`
  ${pageInfoFragment}
  query RemittanceReport(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: RemittanceTopSheetReportFilterInput!
  ) {
    remittanceTopSheetReport(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      edges {
        node {
          id
          total_gross_amount
          rider_name
          order_code
          shipping_method_name
          mall_name
          remarks
          remittance_no
          remitter_name
          rider_name
          status
          courier
          total_adjusted_amount
          total_gross_amount
          manual_adjustment_reasons
          adjustment_total_amount
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export const useRemittanceReportQuery = makeBossQuery<
  RemittanceReport,
  RemittanceReportVariables
>(RemittanceReportQuery);

export const RemittancePendingQuery = gql`
  query RemittancePending($filter: RemittanceTopSheetPendingFilterInput!) {
    remittanceTopSheetPending(filter: $filter) {
      food_and_beverages_total_pending
      general_merchandise_total_pending_shipped
    }
  }
`;

export const useRemittancePendingQuery = makeBossQuery<
  RemittancePending,
  RemittancePendingVariables
>(RemittancePendingQuery);

export const NonRemittanceSummaryQuery = gql`
  query NonRemittanceSummary(
    $orderDate: DateTimeRangeInput!
    $courier: CourierFilter
  ) {
    nonRemittanceSummary(orderDate: $orderDate, courier: $courier) {
      foodAndBeveragesTotalPending
      gmTotalPendingShipped
    }
  }
`;

export const useNonRemittanceSummaryQuery = makeQuery<
  NonRemittanceSummary,
  NonRemittanceSummaryVariables
>(NonRemittanceSummaryQuery);
